import { render, staticRenderFns } from "./DealCard.vue?vue&type=template&id=b3248862&scoped=true"
import script from "./DealCard.vue?vue&type=script&lang=js"
export * from "./DealCard.vue?vue&type=script&lang=js"
import style0 from "./DealCard.vue?vue&type=style&index=0&id=b3248862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3248862",
  null
  
)

export default component.exports